import { CLEAR_NETWORK_BROWSE_GROUP } from 'actions';

export default function clearNetworkBrowseGroup() {
  return {
    type: CLEAR_NETWORK_BROWSE_GROUP,
  };
}
